import React from 'react';

function ActiveCircleIcon({fill1 , fill2 , stroke}) {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="10" r="9.15" fill={fill1} stroke={stroke} strokeWidth="1.7"/>
            <circle cx="10" cy="10" r="6" fill={fill2}/>
        </svg>

    );
}

export default ActiveCircleIcon;
